import API from '../../api';

export async function accountingRequest(path, data = {}) {
    try {
        const result = await API.post(path, data);
        if (!result || result.RELOGIN) throw new Error('نشست شما معتبر نیست؛ دوباره وارد شوید.');
        if (result.ERRORS?.length) throw new Error(result.ERRORS.join(' '));
        return result;
    } catch (error) {
        if (error.response?.data?.data?.ERRORS?.length) {
            const failure = new Error(error.response.data.data.ERRORS.join(' ')); failure.status = error.response.status; throw failure;
        }
        if (error.isAxiosError || error.request) throw new Error('ارتباط با سرور برقرار نشد. اگر در حال ثبت خرید بودید با همین فرم دوباره تلاش کنید.');
        throw error;
    }
}
